import type { ReactElement, ReactNode } from "react";
import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({
  title,
  children,
  action,
}: EmptyStateProps): ReactElement {
  return (
    <div className={styles.empty}>
      <h2 className={styles.title}>{title}</h2>
      {children ? <p className={styles.body}>{children}</p> : null}
      {action}
    </div>
  );
}
